import removeAccents from 'remove-accents'
import { EPathSegment } from './paths'
import { ESuggestType, TSuggestElement } from '../types/factFinder'

const navRegEx = /dpl\/p/

export const appendNavParameter = (url?: string | null): string | undefined => {
  return url === null || url === undefined ? undefined : navRegEx.test(url) ? url.concat('?nav=true') : url
}

const buildUrlFromSuggestion = (suggestion: TSuggestElement): string => {
  switch (suggestion.type) {
    case ESuggestType.PRODUCT: {
      const masterId = suggestion.attributes?.masterId
      return masterId ? `${EPathSegment.PRODUCT}/${masterId}?nav=false` : buildSearchUrl(suggestion.name)
    }
    case ESuggestType.CATEGORY: {
      const value = suggestion.searchParams?.filters?.[0].values?.[0].value
      return value
        ? `${EPathSegment.CATEGORY}/${normalizeUrlPathSegment(value)}?nav=false`
        : buildSearchUrl(suggestion.name)
    }
    case ESuggestType.BRAND:
    default: {
      return buildSearchUrl(suggestion.name)
    }
  }
}

export const normalizeUrlPathSegment = (path: string): string => {
  return removeAccents(
    path
      .toLowerCase()
      .replace(/\u00df/g, 'ss') // replace all 'ß' with 'ss'
      .replace(/\u00e4/g, 'ae') // replace all 'ä' with 'ae'
      .replace(/\u00f6/g, 'oe') // replace all 'ö' with 'oe'
      .replace(/\u00fc/g, 'ue'), // replace all 'ü' with 'ue'
  )
    .replace(/\s/g, '-') // replace all whitespaces with '-'
    .replace(/[^a-z\d-/]/g, '') // remove all characters that are not letters, digits or hyphens
    .replace(/-{2,}/g, '-') // replace all sequences of two or more hyphens with a single hyphen
}

const buildSearchUrl = (query: string): string => `${EPathSegment.SEARCH}?q=${encodeURIComponent(query)}&nav=false`

export default buildUrlFromSuggestion
